import moment from 'moment';
import React, { useEffect } from 'react';
import { RouteConfig } from 'react-router-config';
import { useHistory } from 'react-router-dom';
import {
  getParamFromUrlBatch,
  replaceHistory,
} from '@/infrastructure/history';
import { formatTimeRange } from '@/infrastructure/utils/timestamp';
import { GroupName } from '@/presentation/components/form/components/select-group';
import { MatchMode } from '@/presentation/components/form/standards/types';
import { Loading } from '@/presentation/components/loading';
import { RiskType } from '@/presentation/components/risk-type';
import {
  ComplianceFilter,
  FieldKey,
  VersionFilter,
} from '@/proto/field';
import { TimeType } from '@/proto/metric';
import {
  getIssueListToken,
  getToken,
} from '@/proto/token';

export const EntryRoute = () => {
  const history = useHistory();

  const getComplianceToken = async () => {
    const [
      startTime, endTime, appVersion, issueStatus, translatedStatus, privacyFunc, privacyType,
      problemType, coverStatus, url, backTime, filterSceneProblem, riskType, stackInfo, hostType,
    ] = getParamFromUrlBatch([
      'startTime', 'endTime', 'appVersion', 'issueStatus', 'translatedStatus', 'privacyFunc', 'privacyType',
      'problemType', 'coverStatus', 'url', 'backTime', 'filterSceneProblem', 'riskType', 'stackInfo', 'hostType',
    ]);
    return await getToken({
      ...formatTimeRange([
        startTime || moment().subtract(89, 'days')
          .format('YYYY-MM-DD'),
        endTime || moment().subtract(0, 'days')
          .format('YYYY-MM-DD'),
      ]),
      riskType: riskType || RiskType.Serious,
      issueStatus: issueStatus.split(','),
      translatedStatus,
      stackInfoType: Number.parseInt(stackInfo, 10),
      privacyType,
      url: decodeURIComponent(url),
      [FieldKey.BackTime]: [backTime],
      [FieldKey.FilterSceneProblem]: filterSceneProblem,
      [GroupName.privacyFunction]: decodeURIComponent(privacyFunc).split(','),
      [GroupName.privacyFunctionFilter]: ComplianceFilter.Or,
      [GroupName.problemType]: problemType.split(','),
      [GroupName.problemTypeFilter]: ComplianceFilter.Or,
      [GroupName.coveredStatus]: decodeURIComponent(coverStatus).split(','),
      [GroupName.coveredStatusFilter]: ComplianceFilter.Or,
      [GroupName.hostType]: decodeURIComponent(hostType).split(','),
      [GroupName.hostTypeFilter]: ComplianceFilter.Or,
      [FieldKey.AppVersion]: {
        name: FieldKey.AppVersion,
        values: appVersion.split(','),
        operator: VersionFilter.Or,
      },
    });
  };

  const getIssueToken = async () => {
    const [
      startTime, endTime, appVersion, shiplyTag,
    ] = getParamFromUrlBatch([
      'startTime', 'endTime', 'appVersion', 'shiplyTag',
    ]);
    return await getIssueListToken({
      version: appVersion.split(','),
      startDateStr: startTime || moment().subtract(89, 'days')
        .format('YYYY-MM-DD'),
      endDateStr: endTime || moment().subtract(0, 'days')
        .format('YYYY-MM-DD'),
      timeWindow: TimeType.MONTH,
      standardShiplyAbTestTag: {
        mode: MatchMode.OR,
        values: [shiplyTag],
      },
    });
  };

  const redirect = async () => {
    const [
      route, feature,
    ] = getParamFromUrlBatch([
      'route', 'feature',
    ]);
    if (!route) {
      return;
    }

    const path = decodeURIComponent(route);
    const token = path.startsWith('/compliance') ? await getComplianceToken() : await getIssueToken();
    replaceHistory(history, path, { token, feature });
  };

  useEffect(() => {
    redirect();
  }, []);

  return <div style={{ flex: '1' }}>
    <Loading/>
  </div>;
};


export const entryRoute = (): RouteConfig[] => [
  {
    path: '/entry',
    hideInMenu: true,
    render: () => <EntryRoute />,
  },
];
